import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[${this.props.name || 'AdminComponent'}] Error:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid={`error-boundary-${(this.props.name || 'unknown').toLowerCase().replace(/\s+/g, '-')}`} className="flex flex-col items-center justify-center p-12 text-center rounded-lg border border-red-200 bg-red-50 m-4">
          <AlertTriangle className="w-10 h-10 text-red-400 mb-3" />
          <h3 className="text-lg font-semibold text-red-700 mb-1">
            {this.props.name || 'Section'} failed to load
          </h3>
          <p className="text-sm text-red-500 mb-4">
            An unexpected error occurred. Please try refreshing.
          </p>
          <button
            data-testid={`error-retry-${(this.props.name || 'unknown').toLowerCase().replace(/\s+/g, '-')}`}
            onClick={() => this.setState({ hasError: false, error: null })}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md bg-white border border-red-300 text-red-600 hover:bg-red-50 transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AdminErrorBoundary;
